//全体（テキストエリアのフォーカスない場合）
  // グローバルスコープにtyping変数を宣言（インラインスクリプトからもアクセス可能にするため）
  window.typing = false;
  var typing = window.typing;

  /**
   * 文字入力中の要素か（ショートカット抑制用）
   * Ctrl+Alt+英字は編集中は必ずスキップする
   */
  function lasIsEditableShortcutTarget(el) {
    if (!el || el.nodeType !== 1) {
      return false;
    }
    if (el.isContentEditable) {
      return true;
    }
    var tag = (el.tagName || '').toLowerCase();
    if (tag === 'textarea' || tag === 'select') {
      return true;
    }
    if (tag === 'input') {
      var type = (el.getAttribute('type') || 'text').toLowerCase();
      // ボタン系はショートカットを許可（文字入力ではない）
      var nonText = {
        button: 1, checkbox: 1, radio: 1, submit: 1, reset: 1,
        file: 1, image: 1, hidden: 1, range: 1, color: 1
      };
      return !nonText[type];
    }
    if (el.closest) {
      if (el.closest('[contenteditable="true"], [contenteditable=""]')) {
        return true;
      }
      // 管理表のフローティング textarea エディタ
      if (el.closest('.table-textarea-editor.is-open')) {
        return true;
      }
    }
    return false;
  }

  function lasSyncTypingFlag() {
    var on = lasIsEditableShortcutTarget(document.activeElement);
    window.typing = on;
    typing = on;
  }

  function lasIsTypingForShortcut(event) {
    if (window.typing || typing) {
      return true;
    }
    var t = event && event.target ? event.target : null;
    return lasIsEditableShortcutTarget(t) || lasIsEditableShortcutTarget(document.activeElement);
  }

  function lasIsCtrlAltShortcut(event) {
    return event.ctrlKey && event.altKey && !event.metaKey && !event.shiftKey;
  }

  function lasMatchesLetter(event, letter) {
    var lower = letter.toLowerCase();
    var upper = letter.toUpperCase();
    var key = (event.key || '').toLowerCase();
    return key === lower
      || event.code === 'Key' + upper
      || event.which === upper.charCodeAt(0)
      || event.keyCode === upper.charCodeAt(0);
  }

  // 動的に増える input / textarea も拾う（初期 DOM 直バインドだと漏れる）
  $(document).on('focusin', 'input, textarea, select, [contenteditable="true"], [contenteditable=""]', function () {
    if (lasIsEditableShortcutTarget(this)) {
      window.typing = true;
      typing = true;
    }
  });
  $(document).on('focusout', 'input, textarea, select, [contenteditable="true"], [contenteditable=""]', function () {
    setTimeout(lasSyncTypingFlag, 0);
  });

  window.lasIsEditableShortcutTarget = lasIsEditableShortcutTarget;
  window.lasIsTypingForShortcut = lasIsTypingForShortcut;

  //サイドバー開閉 Ctrl+Alt+D（app.js 二重読込時もハンドラ1本にする）
  if (!window.lasSidebarToggleShortcutBound) {
    window.lasSidebarToggleShortcutBound = true;
    $(document).on('keydown.lasSidebarToggle', function(event){
      if (lasIsTypingForShortcut(event)) {
        return;
      }
      if (!lasIsCtrlAltShortcut(event) || !lasMatchesLetter(event, 'd')) {
        return;
      }
      event.preventDefault();
      $('.siderbar_open_close').trigger('click');
    });
  }

  //ShorCut（ヘッダー求職者検索へ） Ctrl+Alt+C
  $(document).on('keydown', function(event){
    if (lasIsTypingForShortcut(event) || !lasIsCtrlAltShortcut(event) || !lasMatchesLetter(event, 'c')) {
      return;
    }
    event.preventDefault();
    $("input[id='header_s_jobseeker']").focus();
    setTimeout(function(){
      $("input[id='header_s_jobseeker']").val('');
    }, 1);
  });

//求職者詳細ページ
  //ShorCut（アクションログに移動） Ctrl+Alt+A
  $(document).on('keydown', function(event){
    if (lasIsTypingForShortcut(event) || !lasIsCtrlAltShortcut(event) || !lasMatchesLetter(event, 'a')) {
      return;
    }
    event.preventDefault();
    window.location.href = '#action_log';
    $("textarea[name='content']").focus();
    setTimeout(function(){
      $("textarea[name='content']").val('');
    }, 1);
  });

  //ShorCut（求職者情報に移動） Ctrl+Alt+I
  $(document).on('keydown', function(event){
    if (lasIsTypingForShortcut(event) || !lasIsCtrlAltShortcut(event) || !lasMatchesLetter(event, 'i')) {
      return;
    }
    event.preventDefault();
    window.location.href = '#candidate_info';
  });
